"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyboardNavigation = void 0;
exports.KeyboardNavigation = {
    GAMEBOARD: 'KeyA',
    PLAYERSOVERVIEW: 'KeyS',
    HAND: 'KeyD',
    COLONIES: 'KeyF',
};
